export const environment = {
  production: true,
  environment: "qa",
  webApiUrl: "https://enetcloud-demo-enetassess-base-api-testing.azurewebsites.net",
  _webApiUrl: "http://localhost:16102",
  __webApiUrl: "https://enetcloud-demo-enetassess-base-ecitb-api.azurewebsites.net",
  blobStorageUrl: "https://ecomstorageproduction.blob.core.windows.net",
  blobStorageContainer: "base-enetassess-staging",
  _blobStorageContainer: "base-enetassess-ecitb",
  assessBlobStorageContainer: "base-enetassess-staging",
  _assessBlobStorageContainer: "base-enetassess-ecitb",
  eproctUrl: "https://enetcloud-demo-enetassess-base-eproctoring-testing.azurewebsites.net",
  kioskMode: false,
  ecitbMode:true,
  ecomMode:false,
  kioskDownload: "",
  dataSyncItems: [
    {
        "title": "Question Response Media",
        "object": "questionResponseMedia",
        "url": "/assets/data/QuestionResponseMedia.json"
    },
    {
        "title": "Question Responses",
        "object": "questionResponses",
        "url": "/assets/data/QuestionResponses.json"
    },
    {
        "title": "Questions",
        "object": "questions",
        "url": "/assets/data/Questions.json"
    },
    {
        "title": "Schedule Candidates",
        "object": "scheduleCandidates",
        "url": "/assets/data/ScheduleCandidates.json"
    },
    {
        "title": "Schedules",
        "object": "schedules",
        "url": "/assets/data/Schedules.json"
    },
    {
        "title": "Session Questions",
        "object": "sessionQuestions",
        "url": "/assets/data/SessionQuestions.json"
    },
    {
        "title": "Sessions",
        "object": "sessions",
        "url": "/assets/data/Sessions.json"
    },
    {
        "title": "Session Results",
        "object": "sessionResults",
        "url": "/assets/data/SessionResults.json"
    },
    {
        "title": "Mocks",
        "object": "mocks",
        "url": "/assets/data/Mocks.json"
    }
  ],
  previewSyncItems : [
      {
          "title": "Question Responses",
          "object": "questionResponses",
          "url": "/assets/data/QuestionResponses.json"
      },
      {
          "title": "Questions",
          "object": "questions",
          "url": "/assets/data/Questions.json"
      },
      {
          "title": "Question Response Media",
          "object": "questionResponseMedia",
          "url": "/assets/data/QuestionResponseMedia.json"
      }
  ]
};